import {
  ButtonClean,
  ButtonPrimary,
  Modal,
  Box
} from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import React from 'react'

export const CopyConfirmModal = ({ resolve, reject }) => {
  return (
    <Modal
      newDesign
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary onClick={resolve}>
            <Trans>Copy event</Trans>
          </ButtonPrimary>
        </>
      }
      onHide={reject}
    >
      <Box pt="48px" textAlign="left">
        <Box fontSize="18px">
          <Trans>
            Are you sure you want to <strong>copy this event?</strong>
          </Trans>
        </Box>
      </Box>
    </Modal>
  )
}
